import Resizable from './Resizable';

export default Resizable;
